<div class="d-flex flex-column align-items-center">
    <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
        <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
        </div>
        <h5>SEB Instruction URL for {{exam.examinationName}}</h5>
        <form class="mr-0 d-flex flex-column align-items-center">
            <div class="mb-3 mr-0 col-md-10">
                <input type="text" class="form-control" disabled [(ngModel)]="sebInstructionUrl"
                    name="sebInstructionUrl" />
            </div>
        </form>
    </div>
</div>